import { formEncode, handleResponse, nextJsonApi } from '@/API/core';

const contact = {
  insert: async (data: any) => {
    let response = null;
    try {
      response = await nextJsonApi.post('/contact', formEncode(data));
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default contact;
